<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="FORMULARIOS" key="1">
          <g-master name="forms"
                    :endpoint="formMaster.endpoint"
                    :tableSetup="formMaster.tableSetup"
                    :modalFieldsSetup="formMaster.modalFieldsSetup"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Nombre">
                    <a-input
                            v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :label="$t('Tipo de formulario')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_h_form_type', { rules: [{ required: false }] }]"
                              :params="tipo_formulario">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Numero De Columnas')" v-bind="fiOptions">
                    <a-input-number :max="4" style="width: 100%"
                                    v-decorator="['num_cols', { rules: [{ required: false, message: 'Valor requerido' }]}]">
                    </a-input-number>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Estado')" :has-feedback="false">
                    <a-checkbox
                            v-decorator="['status', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
          <a-tabs defaultActiveKey="1">
            <a-tab-pane tab="ENCABEZADOS DE FORMULARIOS" key="1">
              <forms_headers v-if="idForm" :id_form="idForm"></forms_headers>
              <span v-else>Seleccione una formulario para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </a-tab-pane>
      </a-tabs>
    </a-row>

    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tipo_formulario: {
          h_lookup_type: 'FORMS_TYPE'
        },
        visible: false,
        nombre: '',
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        formMaster: {
          actions: {
            actions: [
              {
                name: 'masterEdit',
                text: 'Editar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'edit'}
              },
              {
                name: 'masterDelete',
                text: 'Eliminar',
                permisos: [],
                props: {size: 'small', icon: 'delete', type: 'link'}
              }
            ]
          },
          endpoint: 'forms',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Descripción', dataIndex: 'name', sorter: true},
              {title: 'Formulario', dataIndex: 'h_form_type', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true},
              {title: 'No Columnas', dataIndex: 'num_cols', sorter: true}
            ],
            allowSelect: true,
            selectedRows: []
          },
          modalFieldsSetup: [
            {name: 'name'},
            {name: 'status'},
            {name: 'id_h_form_type'},
            {name: 'num_cols'}
          ]
        }
      }
    },
    computed: {
      idForm () {
        return this.formMaster.tableSetup.selectedRows.length > 0 ? this.formMaster.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Form/Forms.vue